import { apiClient } from '@/lib/api/client'

export type CatalogItemDto = {
  id?: string | null
  code?: string | null
  label?: string | null
  icon?: string | null
}

export async function getCatalogProjectTypesV2(): Promise<CatalogItemDto[]> {
  return await apiClient.get<CatalogItemDto[]>('/api/v2/catalog/project-types')
}

export async function getCatalogLanguagesV2(): Promise<CatalogItemDto[]> {
  return await apiClient.get<CatalogItemDto[]>('/api/v2/catalog/languages')
}

export async function getCatalogCivilitiesV2(): Promise<CatalogItemDto[]> {
  return await apiClient.get<CatalogItemDto[]>('/api/v2/catalog/civilities')
}

export async function getCatalogCustomerTypesV2(): Promise<CatalogItemDto[]> {
  return await apiClient.get<CatalogItemDto[]>('/api/v2/catalog/customer-types')
}
